<template>
    <div>
        <Header :logged="logged" />
        <div id="resultados">
            <b-container v-if="sucesso">
                <b-row>
                    <b-col>
                        <b-alert variant="success" class="text-center" show>
                            <h4 class="alert-heading mb-2"><font-awesome-icon icon="check" class="mr-2" /> Pedido de certidão enviada com sucesso!</h4>
                            <p class="mb-0">Uma mensagem foi enviada para seu e-mail com os dados do pedido.</p>
                            <p>Para mais informações acesse o Painel do Cliente ou <a href="/painel" class="card-link">Clique aqui</a></p>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <Certidao :numero="numero" />
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header'
import Certidao from '../components/Certidao'

import API from '../services/api'

export default {
    name: "sucesso",
    props: ['numero'],
    components: {
        Header,
        Certidao
    },
    data() {
        return {
            logged: false,
            certidao: [],
            data_solicitacao: '',
            sucesso: false
        }
    },
    methods: {
        get_certidao(numero) {
            let self = this
            const token = localStorage.getItem('jwtToken')
            API.get(`certidao/${numero}?token=${token}`).then((res) => {
                //console.log(res);
                self.certidao = res.data[0]
                self.sucesso = true
            })
        }
    },
    mounted() {
        this.$root.isLogged().then(() => {
            this.logged = true
            if(this.numero) this.get_certidao(this.numero)
        }).catch(() => {
            this.logged = false
        })
    }
}
</script>

<style scoped>
#resultados {
  overflow-y: auto;
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 50px;
  height: calc(100% - 80px);
  background-color: var(--main-bg-cinza);
}
</style>
